import React, { useEffect, useState } from "react";
import styles from "./new-chats.module.css";
import UserCard from "../user-card/user-card";
import CustomTextfield from "../../../../../../common/input/custom-textfield/custom-textfield";
import { ArrowLeftOutlined, SearchOutlined } from "@ant-design/icons";
import CustomSelect from "../../../../../../common/input/custom-select/custom-select";
import { Button, Empty, Select, Spin } from "antd";
import { getNewChatList } from "../../../../../../services/communication";
import { useChat } from "../../../../../../context/chat-context";
import InfiniteScroll from "react-infinite-scroll-component";

const NewChats = ({
  showNewChat,
  setShowNewChat,
  selectedChat,
  setSelectedChat,
  chatRoles,
}) => {
  const { resetConversation } = useChat();
  const [search, setSearch] = useState("");
  const [selectedRole, setSelectedRole] = useState("ALL");
  const [newChatList, setNewChatList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const timeOut = setTimeout(() => {
      if (showNewChat) {
        const container = document.getElementById("new-chats-scroll-container");
        container?.scrollTo(0, 0);
        setPage(1);
        setTotalPages(1);
        fetchNewChats();
      } else {
        setSelectedRole("ALL");
        setSearch("");
        setNewChatList([]);
      }
    }, 500);
    return () => {
      clearTimeout(timeOut);
    };
  }, [showNewChat, search, selectedRole]);

  const fetchNewChats = async (currentPage = 1) => {
    try {
      setLoading(true);
      const payload = {
        page: currentPage,
        pageSize: 10,
      };
      if (search) payload.searchKey = search;
      if (selectedRole && selectedRole !== "ALL") payload.role = selectedRole;

      const response = await getNewChatList(payload);
      if (response?.status) {
        const data = response?.data?.data;
        const formattedData = data?.map((item) => ({
          ...item,
          user_id: item?.id,
          user_name: item?.full_name,
          profile_url: item?.profile_picture,
          user_role: item?.role,
          last_message: item?.role,
        }));
        setNewChatList((prev) =>
          currentPage === 1 ? formattedData : [...prev, ...formattedData]
        );
        setTotalPages(response?.data?.totalPages);
        setPage(currentPage);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchNextPage = () => {
    if (!loading && page < totalPages) {
      fetchNewChats(page + 1);
    }
  };

  const handleTabChange = (role) => {
    setSelectedRole(role);
  };

  const handleChatSelect = (userInfo) => {
    setShowNewChat(false);
    if (selectedChat?.user_id !== userInfo?.user_id) {
      resetConversation();
      setSelectedChat(userInfo);
    }
  };

  return (
    <>
      <div className={styles["new-chats-header"]}>
        <div className={styles["new-chats-title-container"]}>
          <Button
            type="text"
            icon={<ArrowLeftOutlined style={{ fontSize: "20px" }} />}
            onClick={() => setShowNewChat(false)}
          />
          <h3>New Chats</h3>
        </div>
        {chatRoles?.length > 1 && (
          <CustomSelect
            placeholder="--Select--"
            value={selectedRole}
            style={{ width: "150px" }}
            onChange={handleTabChange}
            size="large"
          >
            {["ALL", ...chatRoles]?.map((role) => (
              <Select.Option key={role} value={role}>
                {role}
              </Select.Option>
            ))}
          </CustomSelect>
        )}
      </div>

      <CustomTextfield
        id="search"
        placeholder="Search"
        size="large"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className={styles["new-chats-search-bar"]}
        prefix={<SearchOutlined style={{ color: "#98A2B3" }} />}
        allowClear={true}
      />

      <Spin spinning={loading}>
        {!(newChatList?.length > 0) && !loading ? (
          <Empty />
        ) : (
          <div id="new-chats-scroll-container" className={styles["new-chats-list"]}>
            <InfiniteScroll
              dataLength={newChatList?.length}
              next={fetchNextPage}
              hasMore={page < totalPages}
              loader={<div style={{ textAlign: "center", padding: "10px" }}>Loading...</div>}
              scrollableTarget="new-chats-scroll-container"
            >
              {newChatList?.map((user, index) => (
                <UserCard
                  key={index}
                  name={user?.user_name || "Unknown User"}
                  lastmessage={user?.last_message}
                  timeAgo={user?.last_message_at}
                  imgUrl={user?.profile_url}
                  onClick={() => handleChatSelect(user)}
                  isOnline={user?.isOnline}
                  isNewChat={true}
                />
              ))}
            </InfiniteScroll>
          </div>
        )}
      </Spin>
    </>
  );
};

export default NewChats;
